export default "__VITE_ASSET__2jKVr8zK__"